"use client";

import AuthWrapper from "@stadium/hooks/lib/use-auth-wrapper";
import usePathMatcher from "@stadium/hooks/lib/use-path-matcher";

import { ALLOW_SSR_PATHS } from "@constants/routes";

const AuthWrapperClient = ({ children }) => {
  const isSSREnabled = usePathMatcher(ALLOW_SSR_PATHS);

  return <AuthWrapper staticPage={isSSREnabled}>{children}</AuthWrapper>;
};

export default AuthWrapperClient;
